module.exports = __webpack_public_path__ + "img/Group 47.5657b340.png";